import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../../styles/detailStyles.css';
import PCLayout from '../../PCLayout';

const AccoladesDetailPage = ({ isDarkMode, toggleTheme }) => {
    const navigate = useNavigate();
    const [accolades, setAccolades] = useState([]);

    useEffect(() => {
        fetch('/data/accolades.json')
            .then(response => response.json())
            .then(data => setAccolades(data))
            .catch(error => console.error('Error fetching accolades data:', error));
    }, []);

    // Component content

    const handleBack = () => {
        navigate('/misc', { state: { targetSection: 'accolades' } });
    };

    return (
        <PCLayout
            isDarkMode={isDarkMode}
            toggleTheme={toggleTheme}
            activePage="accolades"
        >

            <div className="detailPageContent">
                <div className="inlineBackButtonContainer">
                    <button onClick={handleBack} className="inlineBackButton">
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                </div>
                    {accolades.map((section, index) => (
                        <div className="accoladesDetailCategory" key={index}>
                            <div className="accoladesDetailHeader">
                                <span className="accoladesDetailIcon">
                                    <i className="fa-solid fa-award"></i>
                                </span>
                                <h3 className="accoladesDetailCategoryTitle">{section.title}</h3>
                            </div>
                            <div className="accoladesDetailList">
                                {section.items.map((item, itemIndex) => (
                                    <div key={itemIndex} className="accoladesDetailEntry">
                                        <span className="accoladesDetailMarker">▸</span>
                                        <p className="accoladesDetailDescription">{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
            </div>

        </PCLayout>
    );
};

export default AccoladesDetailPage;
